export default __webpack_public_path__ + "static/media/unbrandedProofPortal.8d0c0f67.png";